import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-car-card',
  templateUrl: './car-card.component.html',
  styleUrls: ['./car-card.component.css']
})
export class CarCardComponent implements OnInit {
  @Input() car;
  @Input() selected: boolean = false;
  @Output() selectCar = new EventEmitter()
  constructor() { }

  ngOnInit() {
    console.log("MACCHINA",this.car)
  }

  select() {
    this.selected = true;
    this.selectCar.emit(this.car)
  }

}
